"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_client_1 = require("apollo-client");
var apollo_link_1 = require("apollo-link");
var apollo_link_error_1 = require("apollo-link-error");
var apollo_link_rest_1 = require("apollo-link-rest");
var camelCase_1 = __importDefault(require("lodash/camelCase"));
var snakeCase_1 = __importDefault(require("lodash/snakeCase"));
var i18n_1 = require("../../i18n");
var settings_1 = require("./settings");
var simpleStore_1 = require("./simpleStore");
exports.getApolloClient = function (language, proxyOverride, authToken) {
    return configureApollo(language, proxyOverride, authToken);
};
var configureApollo = function (language, proxyOverride, authToken) {
    if (language === void 0) { language = i18n_1.DEFAULT_LANGUAGE_CODE; }
    var headers = {
        'Accept-Language': language,
        'X-CSRFToken': simpleStore_1.readCookie('csrf_token') || ''
    };
    if (authToken) {
        headers.Authorization = authToken;
    }
    return new apollo_client_1.ApolloClient({
        link: apollo_link_1.ApolloLink.from([
            apollo_link_error_1.onError(function (_a) {
                var networkError = _a.networkError;
                if (networkError) {
                    // tslint:disable-next-line:no-console
                    console.log("[Network error]: " + networkError);
                }
            }),
            new apollo_link_rest_1.RestLink({
                headers: headers,
                uri: settings_1.getBaseUrl(proxyOverride),
                credentials: 'include',
                fieldNameNormalizer: function (key) { return camelCase_1["default"](key); },
                fieldNameDenormalizer: function (key) { return snakeCase_1["default"](key); }
            }),
        ]),
        cache: new apollo_cache_inmemory_1.InMemoryCache()
    });
};
